import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import dayjs from "dayjs";

const ReemplazoDocumento = () => {
  const [documentos, setDocumentos] = useState([]);
  const [archivos, setArchivos] = useState({});
  const [vencimientos, setVencimientos] = useState({});
  const [errores, setErrores] = useState({});
  const [enviando, setEnviando] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const navigate = useNavigate();
  const [formTouched, setFormTouched] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);

  useEffect(() => {
    const cuit = localStorage.getItem("cuit");
    if (!cuit) return;

    fetch(`/api/getDocumentacionByCUIT?cuit=${cuit}`)
      .then((res) => res.json())
      .then((data) => {
        const rechazados = data.filter(
          (doc) => doc["Estado de Documento"] === "Rechazado" || doc["Estado de Documento"] === "Vencido"
        );
        setDocumentos(rechazados);
      })
      .catch((err) => {
        console.error("❌ Error al cargar documentos:", err);
      });
  }, []);

  const handleArchivo = (e, index) => {
    const file = e.target.files[0];
    setFormTouched(true);
    setArchivos((prev) => ({ ...prev, [index]: file }));
    setErrores((prev) => ({ ...prev, [index]: { ...(prev[index] || {}), file: false } }));
  };

  const handleVencimiento = (e, index) => {
    const fecha = e.target.value;
    setFormTouched(true);
    setVencimientos((prev) => ({ ...prev, [index]: fecha }));
    setErrores((prev) => ({ ...prev, [index]: { ...(prev[index] || {}), fecha: false } }));
  };

  const validarCampos = () => {
    let valido = true;
    const nuevosErrores = {};

    documentos.forEach((doc, index) => {
      const archivo = archivos[index];
      const fecha = vencimientos[index];

      if (!archivo) {
        valido = false;
        nuevosErrores[index] = { ...(nuevosErrores[index] || {}), file: true };
      }

      if (!fecha) {
        valido = false;
        nuevosErrores[index] = { ...(nuevosErrores[index] || {}), fecha: true };
      }
    });

    setErrores(nuevosErrores);
    return valido;
  };

  const handleEnviar = async () => {
    if (!validarCampos()) {
      alert("⚠️ Completá todos los campos obligatorios.");
      return;
    }

    setEnviando(true);
    const formData = new FormData();

    documentos.forEach((doc, index) => {
      const file = archivos[index];
      formData.append("archivos", file);
      formData.append(
        "documentos",
        JSON.stringify({
          idDocumento: doc["ID Documento"],
          nombreDocumento: doc["Tipo de Documento"],
          fechaSubida: dayjs().format("YYYY-MM-DD"),
          fechaVencimiento: vencimientos[index] || "",
        })
      );
    });

    try {
      const res = await fetch("/api/reemplazarDocumento", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      if (res.ok) {
        setSuccessModal(true);
      } else {
        alert("❌ Error: " + data.error);
      }
    } catch (error) {
      console.error("❌ Error:", error);
      alert("❌ Error al conectar con el servidor");
    } finally {
      setEnviando(false);
    }
  };

  const cerrarModal = () => {
    setSuccessModal(false);
    navigate("/gestionproveedoreshome");
  };

  const confirmBack = () => {
    setShowBackModal(false);
    navigate("/gestionproveedoreshome");
  };  

  return (
    <div className="documentacion-container">
      <h2>Reemplazo de Documentos Rechazados</h2>

      {documentos.length === 0 ? (
        <p>No hay documentos rechazados.</p>
      ) : (
        <table className="compact-table">
          <thead>
            <tr>
              <th>Tipo de Documento</th>
              <th>Archivo Nuevo</th>
              <th>Fecha de Vencimiento</th>
            </tr>
          </thead>
          <tbody>
            {documentos.map((doc, index) => (
              <tr key={index}>
                <td>{doc["Tipo de Documento"]}</td>
                <td>
                  <input
                    type="file"
                    accept="application/pdf"
                    onChange={(e) => handleArchivo(e, index)}
                    className={`input-field ${errores[index]?.file ? "error" : ""}`}
                  />
                </td>
                <td>
                  <input
                    type="date"
                    onChange={(e) => handleVencimiento(e, index)}
                    value={vencimientos[index] || ""}
                    className={`input-field ${errores[index]?.fecha ? "error" : ""}`}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div className="button-container">
      <button
        className="secondary-button"
        onClick={() => {
            if (formTouched) setShowBackModal(true);
            else navigate("/gestionproveedoreshome");
        }}
        >
        Volver
        </button>

        {documentos.length > 0 && (
          <button
            className="primary-button"
            onClick={handleEnviar}
            disabled={enviando}
          >
            {enviando ? "Enviando..." : "Reemplazar"}
          </button>
        )}
      </div>

      {successModal && (
        <div className="modal-overlay">
          <div className="modal-content animated-popup">
          <div className="check-icon">✔️</div>
            <p>Documentos reemplazados correctamente</p>
            <div className="modal-buttons">
            <button className="yes-btn" onClick={cerrarModal}>Aceptar</button>
            </div>
          </div>
        </div>
      )}
      {showBackModal && (
        <div className="modal-overlay">
            <div className="modal-content animated-popup">
              <div className="warning-icon">⚠️</div>
              <p>¿Deseás volver? Se perderán los datos ingresados.</p>
              <div className="modal-buttons">
                <button className="yes-btn" onClick={confirmBack}>Sí, volver</button>
                <button className="no-btn" onClick={() => setShowBackModal(false)}>Cancelar</button>
            </div>
          </div>
        </div>
        )}
    </div>
  );
};

export default ReemplazoDocumento;


